import React from "react";

export const PrelatesOutlineSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            xmlns="http://www.w3.org/2000/svg"
            id="svg1"
            version="1.1"
            viewBox="0 0 512 512"
            {...props}
        >
            <g id="g1">
                <path
                    id="path1"
                    fill="currentColor"
                    d="M134.545 511.041c-8.007-3.472-10.204-7.28-14.513-25.157l-3.195-13.25h283.478l-3.44 13.648c-3.723 14.778-4.899 17.687-8.506 21.055-5.955 5.56.448 5.3-130.05 5.258-105.173-.034-120.72-.23-123.774-1.554m-25.923-72.157c-.545-2.062-10.945-44.7-23.11-94.75s-23.305-95.725-24.755-101.5c-2.356-9.375-2.641-12.427-2.667-28.5-.027-16.618.182-18.757 2.718-27.87 4.643-16.685 12.241-31.046 23.362-44.154C90.843 134.243 243.49 6.443 250.457 2.889c5.606-2.86 10.558-2.86 16.161.002 6.295 3.215 159.353 131.12 165.503 138.304 13.92 16.262 22.093 33.245 25.96 53.94 2.407 12.875 1.614 33.325-1.84 47.5-1.408 5.774-12.513 51.45-24.678 101.5-12.164 50.05-22.564 92.687-23.11 94.75l-.992 3.75H109.615Zm157.854-94.09c1.341-.98 3.366-3.025 4.5-4.544 2.012-2.694 2.068-4.017 2.338-55.188l.275-52.428 23.225-.002c20.134 0 23.68-.234 26.653-1.75 10.763-5.488 10.51-20.952-.429-26.248-3.76-1.82-6.175-2-26.816-2h-22.684l-.002-28.25c-.001-24.9-.21-28.662-1.75-31.73-5.378-10.704-21.119-10.704-26.497 0-1.541 3.068-1.749 6.83-1.75 31.73l-.001 28.25h-22.684c-20.641 0-23.057.18-26.816 2-10.94 5.296-11.192 20.76-.429 26.249 2.973 1.516 6.52 1.749 26.679 1.75l23.25.002v50.935c0 33.65.362 51.89 1.067 53.75 3.425 9.04 14.54 12.84 21.871 7.475z"
                ></path>
            </g>
        </svg>
    )
}

export const PrelatesFillSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            xmlns="http://www.w3.org/2000/svg"
            id="svg1"
            version="1.1"
            viewBox="0 0 512 512"
            {...props}
        >
            <g id="g1">
                <path
                    id="path1"
                    fill="currentColor"
                    d="M134.545 511.041c-8.007-3.472-10.204-7.28-14.513-25.157l-3.195-13.25h283.478l-3.44 13.648c-3.723 14.778-4.899 17.687-8.506 21.055-5.955 5.56.448 5.3-130.05 5.258-105.173-.034-120.72-.23-123.774-1.554m-25.923-72.157c-.545-2.062-10.945-44.7-23.11-94.75s-23.305-95.725-24.755-101.5c-2.356-9.375-2.641-12.427-2.667-28.5-.027-16.618.182-18.757 2.718-27.87 4.643-16.685 12.241-31.046 23.362-44.154C90.843 134.243 243.49 6.443 250.457 2.889c5.606-2.86 10.558-2.86 16.161.002 6.295 3.215 159.353 131.12 165.503 138.304 13.92 16.262 22.093 33.245 25.96 53.94 2.407 12.875 1.614 33.325-1.84 47.5-1.408 5.774-12.513 51.45-24.678 101.5-12.164 50.05-22.564 92.687-23.11 94.75l-.992 3.75H109.615Zm157.854-94.09c1.341-.98 3.366-3.025 4.5-4.544 2.012-2.694 2.068-4.017 2.338-55.188l.275-52.428 23.225-.002c20.134 0 23.68-.234 26.653-1.75 10.763-5.488 10.51-20.952-.429-26.248-3.76-1.82-6.175-2-26.816-2h-22.684l-.002-28.25c-.001-24.9-.21-28.662-1.75-31.73-5.378-10.704-21.119-10.704-26.497 0-1.541 3.068-1.749 6.83-1.75 31.73l-.001 28.25h-22.684c-20.641 0-23.057.18-26.816 2-10.94 5.296-11.192 20.76-.429 26.249 2.973 1.516 6.52 1.749 26.679 1.75l23.25.002v50.935c0 33.65.362 51.89 1.067 53.75 3.425 9.04 14.54 12.84 21.871 7.475z"
                ></path>
            </g>
        </svg>
    )
}